/**
 * @generated SignedSource<<1ac3380a063c2852a34335a17334f619>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSchemaRenderContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteLongReadContent" | "blockquoteQuoteContent" | "blockquoteQuoteGenericPostiesArticleContent" | "imageContent" | "inlineWidgetContent" | "photoGalleryWidgetContent" | "scmpYoutubeContent">;
  readonly " $fragmentType": "contentSchemaRenderContent";
};
export type contentSchemaRenderContent$key = {
  readonly " $data"?: contentSchemaRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSchemaRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteLongReadContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteGenericPostiesArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "imageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inlineWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "photoGalleryWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "scmpYoutubeContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "2b4de912bbb7696abc25dd6d62ba85f5";

export default node;
